import encodeFormData from "../../utilities/js/encodeFormData/encodeFormData";

let service;

class ProductsList {
  constructor() {
    this.pageBaseUrl = window.location.href.replace(/\?.*$/, '');
  }

  getProductsList(parameters) {
    const requestUrl = `${this.pageBaseUrl}?${this.showAll()}${this.createParametersString(parameters)}`;

    return fetch(`${requestUrl}&ajax=true`)
      .then(response => {
        if (response.status === 205) {
          window.location.href = requestUrl;
          return null;
        }

        return response.json();

      })
      .then(response => {
        if (response) {
          return {
            state: response,
            url: requestUrl
          };
        }
    });
  }

  showAll() {
    return window.location.search.includes('show=all') ? 'show=all&' : '';
  }

  handleGeneral(url, data, method, credentials) {
    let encodedData, thisUrl;
    if(data) {
      encodedData = encodeFormData(data);
      thisUrl = `${url}${encodedData}`;
    } else {
      thisUrl = `${url}`;
    }

    return fetch(thisUrl, {
      method: method,
      credentials: credentials,
      headers: {
        'Content-Type' : 'application/json; charset=utf-8',
        'Accept': 'application/json'
      }
    })
      .then(response => {
        if(response.status === 200 || response.ok) {
          return response.json();
        }
      })
  }

  createParametersString(parameters) {
    let parametersString = '';

    for (let parameter of parameters) {
      parametersString += `${parameter.name}=${encodeURIComponent(parameter.value)}&`;
    }

    return parametersString.replace(/&$|&{2,}/, '');
  }
}

function productsList() {
  if (service) {
    return service;
  } else {
    service = new ProductsList();
    return service;
  }
}

export default productsList;
